<template>
  <div class="step_container">
    <a-form-model
      :model="firstForm"
      :rules='rules'
      ref="person_first_form"
      layout="horizontal"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <h1 class="step_title">APPLICATION DETAILS 个人信息</h1>
      <!-- 个人信息 -->
      <div class="step_question_container b order_bot_red">
        <h2 class="step_question_title">
          INDIVIDUAL OR SOLE TRADER APPLICATION 申请信息
        </h2>
        <div class="mutiple_form_layout">
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="Title 称谓"
            prop="title"
          >
            <a-select
              :disabled="disabled"
              v-model="firstForm.title"
            >
              <a-select-option value="Mr"> Mr </a-select-option>
              <a-select-option value="Miss"> Miss </a-select-option>
              <a-select-option value="Ms"> Ms </a-select-option>
              <a-select-option value="Other"> Other </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="First Name 名"
            prop="first_name"
          >
            <a-input
              v-model="firstForm.first_name"
              :disabled="disabled"
              @change="(e)=>{
                handleInput(e, 'first_name')
              }"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="Last Name 姓"
            prop="last_name"
          >
            <a-input
              v-model="firstForm.last_name"
              :disabled="disabled"
              @change="(e)=>{
                handleInput(e, 'last_name')
              }"
            />
          </a-form-model-item>
        </div>
        <div class="mutiple_form_layout">
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="Alias name 曾用名"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.personal_other_names_and_aliases"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="Area Code 区号"
            prop="personal_dial_code"
          >
           <a-select
              :disabled="firstForm.personal_dial_code ? true: false"
              v-model="firstForm.personal_dial_code"
            >
              <a-select-opt-group label="Popular Countries">
                <a-select-option
                  v-for="item of popularCountryList"
                  v-bind:key="item.code"
                  :value="item.dial_code"
                >
                  {{ item.name + ' ' + item.dial_code }}
                </a-select-option>
              </a-select-opt-group>
              <a-select-opt-group label="All Countries">
                <a-select-option
                  v-for="item of allCountryList"
                  v-bind:key="item.code"
                  :value="item.dial_code"
                >
                  {{ item.name + ' ' + item.dial_code }}
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="Mobile-Number"
            prop="mobile_phone"
          >
            <a-input
              :disabled="firstForm.mobile_phone?true: false"
              v-model="firstForm.mobile_phone"
              @change="(e)=>{
                handleInput(e, 'mobile_phone')
              }"
            />
          </a-form-model-item>
        </div>
        <!-- 生日 国籍 -->
        <div class="mutiple_form_layout">

          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            required
            label="Date of Birth 生日"
            prop="date_of_birth">
            <a-date-picker
              :disabled="disabled"
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'date_of_birth')
              }"
              :inputReadOnly='true'
              :value="dob_formate"
              placeholder="Date of Birth"
              >
            </a-date-picker>
          </a-form-model-item>
          <BaseCountrySelection
              :style="GetScreenStyle.width30percent"
              label="Nationality 国籍(及地区)"
              :disabled="disabled"
              prop="nationality"
              :selectedVal='firstForm.nationality'
              @handleChange='handleSelect'
              valType='code'
          >
          </BaseCountrySelection>

          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            required
            label="Place of Birth 出生地"
            prop="place_of_birth"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.place_of_birth"
              @change="(e)=>{
                handleInput(e, 'place_of_birth')
              }"
            />
          </a-form-model-item>
        </div>
        <div class="mutiple_form_layout">
          <a-form-model-item
            required
            :style="GetScreenStyle.width60percent"
            label="Email-Address"
            prop="email_address"
          >
            <a-input
            :disabled="disabled"
              v-model="firstForm.email_address"
              @change="(e)=>{
                handleInput(e, 'email_address')
              }"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            required
            label="Gender"
            prop="gender"
          >
            <a-select
              :disabled="disabled"
              v-model="firstForm.gender"
            >
              <a-select-option value="male"> Male 男 </a-select-option>
              <a-select-option value="female"> Female 女</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <!-- 护照号吗 -->
        <div class="mutiple_form_layout">
          <a-form-model-item
            prop="identification_type"
            :style="GetScreenStyle.width45percent"
            label="Identification type(证件类型)"
          >
            <a-select
            :disabled="disabled"
              v-model="firstForm.identification_type"
            >
              <a-select-option value="Passport"> Passport(Recommend) </a-select-option>
              <a-select-option value="birth_certificate"> Birth Certificate </a-select-option>
              <a-select-option value="business_certificate"> Business Certificate </a-select-option>
              <a-select-option value="chinese_id_card"> Chinese ID Card </a-select-option>
              <a-select-option value="citizenship_certificate"> Citizenship Certificate </a-select-option>
              <a-select-option value="eightteen_plus_card"> NZ 18+ Card </a-select-option>
              <a-select-option value="nz_firearm_license"> NZ Firearm License </a-select-option>
              <a-select-option value="nz_au_drivers_licence"> NZ/AU Drivers Licence </a-select-option>
              <a-select-option value="other"> Other </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            required
            :style="GetScreenStyle.width45percent"
            label="ID number 证件号码"
            prop="id_num"
          >
            <a-input
            :disabled="disabled"
              v-model="firstForm.id_num"
              @change="(e)=>{
                handleInput(e, 'id_num')
              }"
            />
          </a-form-model-item>

        </div>
        <!-- 证件上传 -->
        <div class="mutiple_form_layout">
          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            label="Issue Date 签发日期"
            required
            prop="issue_date">
            <a-date-picker
            :disabled="disabled"
              :inputReadOnly='true'
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'issue_date')
              }"
              :value="issue_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <a-form-model-item
          :style="GetScreenStyle.width30percent"
            label="Expiry Date失效日期"
            required
            prop="expiry_date">
            <a-date-picker
              :inputReadOnly='true'
            :disabled="disabled"
              style="width:100%"
              @change="(e)=>{
                handleDatePick(e, 'expiry_date')
              }"
              :value="expiry_date_formate"
              >
            </a-date-picker>
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Issue Country(签发国家)"
            prop="issue_country"
            :disabled="disabled"
            :selectedVal='firstForm.issue_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
        </div>
        <div>
          <div class="step_checkbox_layout">
            <div class="step_sub_title">
              Please upload your ID Vertification 请上传您的ID认证
            </div>
            <ul class="step_ul_style">
              <li>
                Face-to-face channel: with United AU staff assistance to verify
                your documents.
              </li>
              <li>
                Non face-to-face channel: without United AU staff assistance to verify
                your documents.
              </li>
            </ul>
          </div>
          <div>
          <a-form-model-item
            :style="GetScreenStyle.width100percent"
            label="Choose the channel before uploading your proof of identification:"
            prop="prove_channel"
          >
            <a-select
            :disabled="disabled"
              v-model="firstForm.prove_channel"
            >
              <a-select-option value="face_to_face"
                >Face-to-face Channel</a-select-option
              >
              <a-select-option value="none_face_to_face"
                >None Face-to-face Channel
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- face_to_face 上传 -->
          <a-form-model-item
            v-if="firstForm.prove_channel == 'face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              class="modify_antd_radio"
              name="face_to_face_type"
              :disabled="disabled"
              v-model="firstForm.face_to_face_type"
              @change="handleRadio"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese passport 中国护照 (the copy of passport photo, signature page and visa page 护照信息页，签字页和签证页);
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="4">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Other passport 其他护照 (the copy of passport photo,
                    signature page and visa page 护照信息页，签字页和签证页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <!-- none-face-to-face 证件上传 -->
          <a-form-model-item
            v-if="firstForm.prove_channel == 'none_face_to_face'"
            :style="GetScreenStyle.width100percent"
            required
            prop="none_face_to_face_type"
            label="Please choose ONE of the following:"
          >
            <a-radio-group
              class="modify_antd_radio"
              name="none_face_to_face_type"
              v-model="firstForm.none_face_to_face_type"
              @change="handleRadio"
            >
              <a-radio :style="radioStyle" :value="1">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand Passport 澳大利亚/新西兰护照 (the copy
                    of passport photo and signature page 护照信息页和签字页)
                  </li>
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 澳大利亚/新西兰驾照正反面)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="2">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Australia/New Zealand driver licence (the copy of front and
                    back side 驾照正反面)
                  </li>
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
              <a-radio :style="radioStyle" :value="3">
                <ul class="radio_step_ul_style">
                  <li class="li_require">
                    Chinese National ID (the copy of front and back side
                    身份证正反面)
                  </li>
                  <li class="li_require">
                    Chinese bank card (the copy of front and back side
                    银行卡正面)
                  </li>
                  <li>
                    Chinese Passport (the copy of passport photo, signature page
                    and visa page 护照信息页，签字页和签证页《如有》)
                  </li>
                </ul>
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <div v-if="prove_channel">
             <AFileMessage
              v-for="item in idProve[firstForm.prove_channel][proveIndex]"
              :key="item.id"
              :obj='item'
              @handleFileChange="handleFileList"
              @handleInput='handleInput'
              @FileValidate='FileValidate'
              @handleSelect='(e, val)=> {handleSelect(val,e)}'
              :disabled="disabled"
            />
          </div>
          </div>
        </div>
        <!-- 税务信息 -->
        <div class="step_checkbox_layout">
          <div>
            <!-- 新西兰本地税务信息 -->
            <div class="step_sub_title">
              Are you an Australia Tax Resident? 您是否是澳大利亚/新西兰税务居民？
            </div>
            <ul class="step_ul_style">
              <li>
                If NO, you must provide your tax residence details in the other
                countries at below
              </li>
              <li>若不是，您需要提供你其他国家的税务信息</li>
            </ul>
            <div class="step_checkbox_layout">
              <a-form-model-item
                :style="GetScreenStyle.width45percent"
                prop="is_nz_tax_resident"
              >
              <a-radio-group
                class="modify_antd_radio_id"
                :disabled="disabled"
                @change="handleRadio"
                v-model="firstForm.is_nz_tax_resident"
                name="is_nz_tax_resident"
              >
                <a-radio :value="true"> Yes 是 </a-radio>
                <a-radio :value="false"> No 否 </a-radio>
              </a-radio-group>
              </a-form-model-item>
            </div>
            <div class="marginT_10" v-if="is_nz_tax_resident == true">
              <a-form-model-item
                :style="GetScreenStyle.width45percent"
                label="IRD/Tax Number 税号"
                prop="nz_ird_num"
              >
                <a-input
                  :disabled="disabled"
                  v-model="firstForm.nz_ird_num"
                />
              </a-form-model-item>
              <div class="step_sub_title">
                Are you a tax resident of another country?
                您是否还有其他国家的税务信息？
              </div>
              <ul class="step_ul_style">
                <li>
                  If YES, please list your tax residence details in all the
                  other countries below
                </li>
                <li>若是，请提供其他国家的税务信息</li>
              </ul>
              <div class="step_checkbox_layout">
                <a-form-model-item
                  :style="GetScreenStyle.width100percent"
                  prop="has_other_country_tax"
                >
                  <a-radio-group
                    class="modify_antd_radio_id"
                    :disabled="disabled"
                    @change="handleRadio"
                    required
                    v-model="firstForm.has_other_country_tax"
                    name="has_other_country_tax"
                  >
                    <a-radio :value="true"> Yes 是 </a-radio>
                    <a-radio :value="false"> No 否 </a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </div>
            </div>
            <div
              class="step_checkbox_layout"
              v-if="
                is_nz_tax_resident == false ||
                (is_nz_tax_resident == true && has_other_country_tax == true)
              "
            >
              <!-- 是否有其他国家的 税务信息  -->
              <a-tabs
                v-model="activeKey"
                type="editable-card"
                @edit="onEdit"
                :hideAdd="panes && panes.length >= 3"
              >
                <a-tab-pane
                  v-for="pane in panes"
                  :key="pane.key"
                  :tab="pane.title"
                  :closable="pane.closable"
                >
                <a-form-model-item
                :style="GetScreenStyle.width100percent"
                prop="panes"
                >
                  <div class="mutiple_form_layout">
                    <BaseCountrySelection
                      :style="GetScreenStyle.width45percent"
                      label="Country of Tax Residence 税务国家"
                      :disabled="disabled"
                      :selectedVal='pane.content.other_tax_contry'
                      @handleChange='(variable,value) => {
                            handleOtherTaxCountry(value, pane.key);
                          }'
                      valType='code'
                    >
                    </BaseCountrySelection>
                    <a-form-model-item
                      :style="GetScreenStyle.width45percent"
                      label="Tax Number 税号"
                      required
                    >
                      <a-input
                        :disabled="disabled"
                        @change="
                          (e) => {
                            handleOtherTaxNum(e, pane.key);
                          }
                        "
                        :value="pane.content.other_tax_num"
                      />
                    </a-form-model-item>
                  </div>
                </a-form-model-item>
                </a-tab-pane>
              </a-tabs>
              <div v-if="has_us_taxer">
                    <AUploadFile
            title="If you are a US taxer you need to download and fill the form below "
            prop="us_taxer_file_list"
            :fileList="us_taxer_file_list"
            :disabled="disabled"
            @handleFileChange="handleFileList"
            >
            <a class=" border-black-85 py-2 px-4 border my-2 inline-block rounded-md shadow-md text-sm" href="https://public-nzsky-files.s3-ap-southeast-2.amazonaws.com/fw9.pdf" download>
            Click this
            </a>
            </AUploadFile>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 地址信息 -->
      <div class="step_question_container border_bot_red">
        <h2 class="step_question_title">
          ADDRESS AND CONTACT DETAILS 地址信息
        </h2>
        <div>
          <div class="mutiple_form_layout">
          <a-form-model-item
            required
            :style="GetScreenStyle.width60percent"
            label="Residential Address(No Po BOX) 居住地址"
            prop="residential_address"
          >
            <BaseAddress
              prop="residential_address"
              :disabled="disabled"
              :value="firstForm.residential_address"
              @handleChange='handleSelect'
            />
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Country 国家(及地区)"
            prop="country"
            :disabled="disabled"
            :selectedVal='firstForm.country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
          </div>
          <div class="mutiple_form_layout">
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              label="City 城市"
              prop="city"
            >
              <a-input
                :disabled="disabled"
                v-model="firstForm.city"
              />
            </a-form-model-item>
             <a-form-model-item
            required
            :style="GetScreenStyle.width30percent"
            label="Suburb 地区"
            prop="residential_address"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.suburb"
            />
          </a-form-model-item>
            <a-form-model-item
              :style="GetScreenStyle.width30percent"
              required
              prop="postcode"
              label="PostCode 邮政编码"
            >
              <a-input
                :disabled="disabled"
                v-model="firstForm.postcode"
              />
            </a-form-model-item>
          </div>
          <!-- 上传地址证明 -->
          <div class="step_checkbox_layout">
            <div class="step_sub_title">
              Please upload your address verification 请上传您的地址认证
            </div>
            <a-form-model-item required prop="address_prove_type">
              <a-radio-group
                class="modify_antd_radio"
                name="address_prove_type"
                :disabled="disabled"
                :value="address_prove_type"
                @change="handleRadio"
              >
                <a-radio :style="radioStyle" :value="1">
                  Bank Statements and Bank Correspondence 银行对账单和银行通信
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Utility Bill 各种账单
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Government Agency Correspondence (Council Rates, etc.)
                  政府机构通信</a-radio
                >
                <a-radio :style="radioStyle" :value="4">
                  Electoral Commission Correspondence 选举委员会函件</a-radio
                >
                <a-radio :style="radioStyle" :value="5">
                  Tenancy Agreement 租赁协议</a-radio
                >
                <a-radio :style="radioStyle" :value="6">
                  Vehicle Registration 车辆登记</a-radio
                >
              </a-radio-group>
            </a-form-model-item>
            <div class="step_checkbox_layout">
              <div v-if="address_prove_type == 1">
                <ul class="step_ul_style">
                  <li>
                    This must be a statement from a bank/IRD that has been
                    posted to the client and is dated within the last 3 months.
                    这必须是银行/
                    IRD的记录，该记录信件必须是最近三个月内通过信件发送给注册人的。
                  </li>
                  <li>
                    Bank correspondence must confirm a business relationship
                    exists between the bank and the client.
                    银行通信必须是能确认银行与注册人之间存在业务关系的
                  </li>
                  <li>
                    Printed information from online account or email
                    correspondence is not acceptable unless it is JP/lawyer
                    certified. 除非获得JP
                    /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                  </li>
                </ul>
              </div>
              <div v-if="address_prove_type == 2">
                <ul class="step_ul_style">
                  <li>
                    This must be a statement for utility service at a fixed
                    location that has been posted to the client and is dated
                    within the last 3 months.
                    这必须最近三个月内通过邮寄发送去注册人的账单。
                  </li>
                  <li>
                    Fixed services include electricity, water, gas, home
                    internet/landlines and Sky.
                    服务账单包括电力，水，煤气，家庭互联网/固定电话和电视。
                  </li>
                  <li>
                    Fixed services include electricity, water, gas, home
                    internet/landlines and Sky.
                    服务账单包括电力，水，煤气，家庭互联网/固定电话和电视。
                  </li>
                  <li>
                    Printed information from online account or email
                    correspondence is not acceptable unless it is JP/lawyer
                    certified. . 除非获得JP
                    /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                  </li>
                </ul>
              </div>
              <div v-if="address_prove_type == 3">
                <ul class="step_ul_style">
                  <li>
                    This must be a statement, letter or invoice that has been
                    posted to the client from a government agency and is dated
                    within the last 3 months.
                    这必须最近三个月内来自政府机构通过邮寄发送去注册人的声明/信件/发票。
                  </li>
                  <li>
                    This includes confirmation of bond lodgements with the
                    Department of Building and Housing.
                    这可以是来自于建筑和住房部押金投管确认信
                  </li>
                  <li>
                    This includes confirmation of bond lodgements with the
                    Department of Building and Housing.
                    这可以是来自于建筑和住房部押金投管确认信
                  </li>
                </ul>
              </div>
              <div v-if="address_prove_type == 4">
                <ul class="step_ul_style">
                  <li>
                    This must be a letter that has been posted to the client and
                    is dated within the last 3 months.
                    这必须是三个月内通过邮寄发送至注册人的信件
                  </li>
                  <li>
                    unless it is JP/lawyer certified. . 除非获得JP
                    /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                  </li>
                </ul>
              </div>
              <div v-if="address_prove_type == 5">
                <ul class="step_ul_style">
                  <li>
                    This must be a signed tenancy agreement dated within the
                    last 3 months. 这必须是过去3个月内签署的租赁协议
                  </li>
                </ul>
              </div>
              <div v-if="address_prove_type == 6">
                <ul class="step_ul_style">
                  <li>
                    This must be a current vehicle registration that has been
                    posted to the client and is dated within the last 3 months.
                    这必须是三个月内通过邮寄发送给注册人的车辆登记信件
                  </li>
                  <li>
                    Printed information from online account or email
                    correspondence is not acceptable unless it is JP/lawyer
                    certified. . 除非获得JP
                    /律师认证，否则我们不接受来自在线帐户或电子邮件通信的打印信息。
                  </li>
                </ul>
              </div>
              <div
              v-if="address_prove_type>0"
              class="step_upload_box marginT_10">
                    <AUploadFile
                      @FileValidate="FileValidate"
                      title=""
                      :disabled="disabled"
                      :prop="addressProve[address_prove_type-1].type_str"
                      :fileList="addressProve[address_prove_type-1].type"
                      @handleFileChange="handleFileList"
                    />
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工作情况 -->
      <div class="step_question_container border_bot_green">
        <h2 class="step_question_title">
          EMPLOYMENT/BUSINESS DETAILS (Optional) 工作情况/商业详情
        </h2>
        <div class="mutiple_form_layout">
          <a-form-model-item
          prop="employer_company_name"
            required
            :style="GetScreenStyle.width45percent"
            label="Employer/Trading Name 公司名称"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.employer_company_name"
              placeholder="若无工作可填写家庭主妇、无业等"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width45percent"
            label="Business Number 公司注册号"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.business_registration"
            />
          </a-form-model-item>
        </div>
        <div class="mutiple_form_layout">
          <a-form-model-item
            :style="GetScreenStyle.width45percent"
            label="Business Email 公司邮箱"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.business_email"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width45percent"
            label="产业类型 Industry"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.business_engaged_industry"
            />
          </a-form-model-item>
        </div>
        <a-form-model-item
          label="Business Physical Address(No Po BOX) 公司地址"
        >
          <BaseAddress
              prop="employer_company_address"
              :disabled="disabled"
              :value="firstForm.employer_company_address"
              @handleChange='handleSelect'
            />
        </a-form-model-item>
        <div class="mutiple_form_layout">
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="City 城市"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.employer_company_city"
            />
          </a-form-model-item>
          <BaseCountrySelection
            :style="GetScreenStyle.width30percent"
            label="Country 国家(及地区)"
            :disabled="disabled"
            prop="employer_company_country"
            :selectedVal='firstForm.employer_company_country'
            @handleChange='handleSelect'
            valType='code'
          >
          </BaseCountrySelection>
          <a-form-model-item
            :style="GetScreenStyle.width30percent"
            label="PostCode 邮政编码"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.employer_company_post_code"
            />
          </a-form-model-item>
        </div>
        <div class="mutiple_form_layout">
          <a-form-model-item
            prop="employer_job_title"
            :style="GetScreenStyle.width30percent"
            label="Job Title 职位"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.employer_job_title"
            />
          </a-form-model-item>
          <a-form-model-item
            :style="GetScreenStyle.width60percent"
            label="Business Phone Number 商务电话"
          >
            <a-input
              :disabled="disabled"
              v-model="firstForm.employer_phone_number"
            />
          </a-form-model-item>
        </div>
      </div>
    </a-form-model>
  </div>
</template>

<script>
import rules from '@/assets/rules/oneRules.js'
import { mapGetters, mapActions, mapState } from 'vuex'
import AFileMessage from '@/components/AFileMessage'
import AUploadFile from '@/components/AUploadFile'
import BaseCountrySelection from '@/components/BaseCountrySelection'
import BaseAddress from '@/components/BaseAddress.vue'
import moment from 'moment'

export default {
  created () {
    this.rules = rules
  },

  components: {
    AFileMessage,
    BaseAddress,
    AUploadFile,
    BaseCountrySelection
  },
  methods: {
    FileValidate (val) {
      if (val) {
        this.$refs.person_first_form.validateField([val])
      } else {
        this.$refs.person_first_form.validate()
      }
    },
    handleFileList (fileList, content) {
      this.ChangeObjectAction({ content, value: fileList })
    },
    handleOtherTaxCountry (val, param) {
      const index = this.panes.findIndex(item => item.key === param)
      this.panes[index].content.other_tax_contry = val
      this.ChangeObjectAction({ content: 'panes', value: this.panes })
    },
    handleOtherTaxNum (e, param) {
      const val = e.target.value
      const index = this.panes.findIndex(item => item.key === param)
      this.panes[index].content.other_tax_num = val
      this.ChangeObjectAction({ content: 'panes', value: this.panes })
    },
    handleCheck (e) {
      const { checked, name } = e.target
      this.ChangeFormAction({ content: name, value: checked })
    },
    onEdit (targetKey, action) {
      if (this.disabled) {
        return
      }
      this[action](targetKey)
    },
    add () {
      const _panes = this.panes
      _panes.push({ title: 'Tax Number 税务信息 # ' + (this.getLastPanesKey + 2), content: { other_tax_contry: null, other_tax_num: null }, key: this.getLastPanesKey + 1 })
      this.activeKey = this.getLastPanesKey
      this.ChangeObjectAction({ content: 'panes', value: _panes })
    },
    remove (targetKey) {
      let activeKey = this.activeKey
      let _panes = {}
      let lastIndex
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1
        }
      })
      _panes = this.panes.filter(pane => pane.key !== targetKey)
      if (lastIndex >= 0) {
        activeKey = this.panes[lastIndex].key
      } else {
        activeKey = this.panes[0].key
      }
      this.activeKey = activeKey
      this.ChangeObjectAction({ content: 'panes', value: _panes })
    },
    handleRadioHasOtherTax (e) {
      const { value } = e.target
      this.has_other_country_tax = value
    },
    onAddTypeSelect (e) {
      const { value } = e.target
      this.address_prove_type = value
    },
    handleInput (e, content) {
      const { value } = e.target
      const _value = value.replace(/[\u4E00-\u9FA5]/g, '')
      this.ChangeFormAction({ content, value: _value })
    },
    handleRadio (e) {
      const { name, value } = e.target
      this.ChangeFormAction({ content: name, value })
    },
    handleSelect (content, value) {
      this.ChangeFormAction({ value, content })
    },
    handleDatePick (value, content) {
      if (value) {
        this.ChangeFormAction({ content, value: value.format() })
      }
    },
    ...mapActions('personStepOne', ['ChangeFormAction', 'ChangeObjectAction'])
  },
  data () {
    return {
      p_type: 'face_to_face',
      p_select: 1,
      activeKey: 0,
      radioStyle: {
        lineHeight: '30px',
        width: '100%',
        marginBottom: '10px'
      },
      labelCol: { span: 24 },
      wrapperCol: { span: 24 }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.disabled) {
      next()
    } else {
      this.$refs.person_first_form.validate(valid => {
        if (valid) {
          next()
        } else {
          next()
        }
      })
    }
  },
  computed: {
    addressProve () {
      return [
        { id: 1, type: this.bank_stament_address_file_list, type_str: 'bank_stament_address_file_list' },
        { id: 2, type: this.utility_address_file_list, type_str: 'utility_address_file_list' },
        { id: 3, type: this.government_correspondence_address_file_list, type_str: 'government_correspondence_address_file_list' },
        { id: 4, type: this.commission_correspondence_address_file_list, type_str: 'commission_correspondence_address_file_list' },
        { id: 5, type: this.tenancy_agreement_address_file_list, type_str: 'tenancy_agreement_address_file_list' },
        { id: 6, type: this.vehicle_register_address_file_list, type_str: 'vehicle_register_address_file_list' }
      ]
    },
    dob_formate () {
      if (this.date_of_birth) {
        return moment(this.date_of_birth)
      }
      return null
    },
    issue_date_formate () {
      if (this.issue_date) {
        return moment(this.issue_date)
      }
      return null
    },
    expiry_date_formate () {
      if (this.expiry_date) {
        return moment(this.expiry_date)
      }
      return null
    },
    nzPassportFile () {
      return {
        id: 15,
        desc: 'Australia/New Zealand Passport 新西兰/澳大利亚护照 (the copy of passport photo and signature page 护照信息页和签字页) ',
        message: [{
          mid: 52,
          proof_num: this.nz_au_passport_num,
          proof_num_str: 'nz_au_passport_num',
          belongs_to: this.nz_au_passport_country,
          belongs_to_str: 'nz_au_passport_country',
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 53,
            title: 'Australia/New Zealand护照信息页+签字页',
            prop: 'nz_au_passport_file_list',
            file: this.nz_au_passport_file_list
          }
        ]
      }
    },
    nzDriverFile () {
      return {
        id: 2,
        desc: 'Australia/New Zealand driver licence (the copy of front and back side 新西兰/澳大利亚驾照正反面)',
        message: [{
          mid: 1,
          proof_num: this.nz_au_driver_num,
          proof_num_str: 'nz_au_driver_num',
          belongs_to: this.nz_au_driver_country,
          belongs_to_str: 'nz_au_driver_country',
          belongs_to_str_disabled: false,
          country_selection: [
            {
              name: 'Australia',
              dial_code: '+61',
              code: 'AU'
            },
            {
              name: 'New Zealand',
              dial_code: '+64',
              code: 'NZ'
            }
          ]
        }],
        upload: [
          {
            fid: 2,
            title: '澳大利亚/新西兰驾照正面',
            prop: 'nz_au_driver_front_file_list',
            file: this.nz_au_driver_front_file_list
          },
          {
            fid: 3,
            title: '澳大利亚/新西兰驾照反面',
            prop: 'nz_au_driver_back_file_list',
            file: this.nz_au_driver_back_file_list
          }
        ]
      }
    },
    cnPassport () {
      return {
        id: 3,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页) ',
        message: [
          {
            mid: 1,
            proof_num: this.cn_passport_num,
            proof_num_str: 'cn_passport_num',
            belongs_to: this.cn_passport_country,
            belongs_to_str: 'cn_passport_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 4,
            title: '中国护照信息页+签字页',
            prop: 'cn_passport_file_list',
            file: this.cn_passport_file_list
          },
          {
            fid: 5,
            title: '中国护照签证页',
            prop: 'cn_passport_visa_file_list',
            file: this.cn_passport_visa_file_list
          }
        ]
      }
    },
    cnIdentify () {
      return {
        desc: 'Chinese National ID (the copy of front and back side 身份证正反面) ',
        id: 5,
        message: [
          {
            mid: 3,
            proof_num: this.cn_identify_front_num,
            proof_num_str: 'cn_identify_front_num',
            belongs_to: this.cn_identify_front_country,
            belongs_to_str: 'cn_identify_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 6,
            title: '中国身份证正面',
            prop: 'cn_identify_front_file_list',
            file: this.cn_identify_front_file_list
          },
          {
            fid: 7,
            title: '中国身份证反面',
            prop: 'cn_identify_back_file_list',
            file: this.cn_identify_back_file_list
          }
        ]
      }
    },
    cnBankCard () {
      return {
        id: 6,
        desc: 'Chinese bank card (the copy of front and back side 银行卡正面)',
        message: [
          {
            mid: 4,
            proof_num: this.cn_bank_front_num,
            proof_num_str: 'cn_bank_front_num',
            belongs_to: this.cn_bank_front_country,
            belongs_to_str: 'cn_bank_front_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 8,
            prop: 'cn_bank_front_file_list',
            title: '中国银行卡正面',
            file: this.cn_bank_front_file_list
          }
        ]
      }
    },
    cnPassportOption () {
      return {
        id: 7,
        desc: 'Chinese passport 中国护照 (the copy of passport photo护照信息页)(如有)',
        message: [
          {
            mid: 5,
            proof_num: this.cn_passport_not_required_num,
            proof_num_str: 'cn_passport_not_required_num',
            belongs_to: this.cn_passport_not_required_country,
            belongs_to_str: 'cn_passport_not_required_country',
            belongs_to_str_disabled: true,
            country_selection: [
              {
                name: 'China',
                dial_code: '+86',
                code: 'CN'
              }
            ]
          }
        ],
        upload: [
          {
            fid: 10,
            title: '中国护照信息页+签字页(如有)',
            prop: 'cn_passport_not_required_file_list',
            file: this.cn_passport_not_required_file_list
          },
          {
            fid: 11,
            title: '中国护照签证页(如有)',
            prop: 'cn_passport_not_required_visa_file_list',
            file: this.cn_passport_not_required_visa_file_list
          }
        ]
      }
    },

    otherPassport () {
      return {
        id: 9,
        desc: 'Other passport 其他护照 (the copy of passport photo 护照信息页)',
        message: [
          {
            mid: 7,
            proof_num: this.other_identify_num,
            proof_num_str: 'other_identify_num',
            belongs_to: this.other_identify_country,
            belongs_to_str: 'other_identify_country',
            belongs_to_str_disabled: false,
            country_selection: this.allCountryList
          }
        ],
        upload: [
          {
            fid: 12,
            title: '其他护照信息页+签字页',
            prop: 'other_identify_file_list',
            file: this.other_identify_file_list
          },
          {
            fid: 13,
            title: '其他护照签证页',
            prop: 'other_passport_visa_file_list',
            file: this.other_passport_visa_file_list
          }
        ]
      }
    },

    proveIndex () {
      if (this.prove_channel === 'face_to_face') {
        return this.face_to_face_type - 1
      } else if (
        this.prove_channel === 'none_face_to_face'
      ) {
        return this.none_face_to_face_type - 1
      } else {
        return 0
      }
    },
    idProve () {
      return {
        face_to_face: [
          [
            this.nzPassportFile
          ],
          [
            this.cnPassport,
            this.cnIdentify
          ],
          [
            this.cnPassport,
            this.nzDriverFile
          ],
          [
            this.otherPassport,
            this.nzDriverFile
          ]
        ],
        none_face_to_face: [
          [
            this.nzPassportFile,
            this.nzDriverFile
          ],
          [
            this.nzDriverFile,
            this.cnIdentify,
            this.cnPassportOption
          ],
          [
            this.cnIdentify,
            this.cnBankCard,
            this.cnPassportOption
          ]
        ]
      }
    },
    firstForm () {
      return this.$store.state.personStepOne
    },
    getLastPanesKey () {
      return this.panes[this.panes.length - 1].key || 0
    },
    ...mapGetters({
      disabled: 'login/getComplainceActive'
    }),
    ...mapState('personStepOne', ['title', 'first_name', 'personal_dial_code', 'last_name', 'personal_other_names_and_aliases', 'email_address', 'mobile_phone', 'gender', 'identification_type', 'date_of_birth', 'place_of_birth', 'nationality', 'expiry_date', 'issue_date', 'id_num', 'issue_country', 'is_nz_tax_resident', 'cn_passport_visa_file_list', 'residential_address', 'suburb', 'nz_ird_num', 'city', 'country', 'postcode', 'address_prove_type', 'other_passport_visa_file_list', 'employer_company_name', 'employer_company_address', 'employer_company_city', 'business_email', 'employer_company_country', 'employer_company_post_code', 'business_engaged_industry', 'business_registration', 'employer_job_title', 'employer_phone_number', 'passport_file_list', 'nationalID_file_list', 'driver_license_file_list', 'bank_stament_address_file_list', 'utility_address_file_list', 'government_correspondence_address_file_list', 'commission_correspondence_address_file_list', 'tenancy_agreement_address_file_list', 'us_taxer_file_list', 'vehicle_register_address_file_list', 'has_other_country_tax', 'panes', 'nz_au_passport_file_list', 'nz_au_driver_front_file_list', 'nz_au_driver_back_file_list', 'cn_passport_file_list', 'cn_identify_file_list', 'cn_identify_front_file_list', 'cn_identify_back_file_list', 'other_identify_file_list', 'cn_bank_front_file_list', 'cn_bank_back_file_list', 'cn_passport_not_required_file_list', 'cn_passport_not_required_visa_file_list', 'tax_residence_us_person', 'prove_channel', 'face_to_face_type', 'none_face_to_face_type', 'nz_au_passport_num', 'nz_au_passport_country', 'nz_au_driver_num', 'nz_au_driver_country', 'cn_passport_num', 'cn_passport_country', 'cn_passport_visa_num', 'cn_passport_visa_country', 'cn_identify_front_num', 'cn_identify_front_country', 'cn_bank_front_num', 'cn_bank_front_country', 'cn_passport_not_required_num', 'authorize1_cn_passport_country', 'cn_passport_not_required_visa_num', 'cn_passport_not_required_visa_country', 'other_identify_num', 'other_identify_country', 'other_passport_visa_num', 'other_passport_visa_country', 'cn_passport_not_required_country']),
    ...mapState('countrySelection', ['popularCountryList', 'allCountryList']),
    ...mapGetters('layout', ['GetScreenStyle']),
    ...mapGetters('personStepOne', ['has_us_taxer'])
  }
}
</script>

<style scoped>
.step_upload_box {
  border-bottom: 1px solid rgba(0, 0, 0, 0.45);
}
.mutiple_form_layout {
  display: flex;
  justify-content: space-between;
}
.step_container {
  background: rgb(248, 248, 248);
  padding: 0 1rem;
}
.step_notice_text {
  font-size: 13px;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.65);
}
.step_checkbox_layout {
  margin-top: 20px;
}

.ant-form-item-label .ant-form-item-required {
  font-size: 16px;
  color: red;
}
.step_sub_title {
  margin: 20px 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
}
.radio_step_ul_style {
  padding-left: 5px;
  font-size: 16px;
  font-weight: 300;
}
.radio_step_ul_style li {
  line-height: 24px;
}

.step_ul_style {
  padding-left: 20px;
  font-size: 16px;
  font-weight: 300;
}
.step_ul_style li {
  line-height: 24px;
}
.marginT_10 {
  margin-top: 10px;
}
.border_bot_red {
  border-bottom: 2px solid #f32e59;
}
.border_bot_green {
  border-bottom: 2px solid #2baf6f;
}
.modify_antd_radio >>> .ant-radio-inner {
  width: 26px;
  height: 26px;
}
.modify_antd_radio >>> .ant-radio-wrapper {
  white-space: pre-wrap;
  display: flex;
}
.modify_antd_radio >>> .ant-radio-inner::after {
  width: 12px;
  left: 6px;
  top: 6px;
  height: 12px;
}
.modify_antd_radio >>> .ant-radio-checked::after {
  height: 25px;
}
.step_ul_style li::before {
  content: "\2022";
  color: #999;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1rem;
}
.step_ul_style .li_require::before {
  content: "\2022";
  color: red;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1rem;
}
.ant-form >>> label {
  font-size: 15px;
}
@media only screen and (max-width: 768px) {
  .mutiple_form_layout {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
